module.exports = __webpack_public_path__ + "img/portlands-logo.36958d4c.svg";